import { autoBroadcastsReducer } from '../features/autoBroadcasts/store/autoBroadcastsSlice';
import { visitorsApi } from '../features/visitors/service/visitors.api';
import { broadcastsApi } from '../features/massBroadcasts/service/broadcasts.api';
import { autoBroadcastsApi } from '../features/autoBroadcasts/service/autoBroadcasts.api';
import { exportsApi } from '../features/exports/service/exports.api';

export const crmApi = [
    autoBroadcastsApi.middleware,
    broadcastsApi.middleware,
    exportsApi.middleware,
    visitorsApi.middleware,
];

export const crmReducers = {
    [broadcastsApi.reducerPath]: broadcastsApi.reducer,
    [autoBroadcastsApi.reducerPath]: autoBroadcastsApi.reducer,
    [exportsApi.reducerPath]: exportsApi.reducer,
    [visitorsApi.reducerPath]: visitorsApi.reducer,

    autoBroadcast: autoBroadcastsReducer,
};
